import { SVGProps } from 'react';

const Squirrel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.236 22a3 3 0 0 0-2.2-5M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4m0 9h.01M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 0 0-9 0 2.5 2.5 0 1 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10"
    />
  </svg>
);
export default Squirrel;
